import React, { Component } from 'react';
import ButtonIcon from '../../../button';
import { ListTabButton } from '../../list-tab/list-tab-button.component';
import Icons from '../../../icon';
export default class ManageLayout extends Component {

    constructor(props) {
        super(props);
        this.state={
            selectedIndex:0,
        }
    }


    FilterIndex(tabIndex){    
        this.setState({selectedIndex:tabIndex});  
        this.props.onGetSelected(tabIndex) 
    }

    CloseForm() {       
       this.props.closeForm(false)
    }

    render(){
        return(
            <div className={`remove-background request-table data-table ${this.props.customClassName} fit-width`}>
                 <ButtonIcon onClick={this.CloseForm.bind(this)} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName={this.props.buttonLabel}/> 
                 <div className="request-table data-table ">
                       {this.props.haveHeaderButton && 
                        <div className="button-right-container">
                            <ButtonIcon onClick={()=>alert("click")} customClassName="header-filter-button" labelName="MJE"/> 
                            <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-filter-button" labelName="E-Bill Extract"/>                             
                            <ButtonIcon onClick={()=>alert("click")}  customClassName="header-filter-button" labelName="Cost Allocation"/> 
                        </div>
                       }
                        {
                            this.props.haveStatusLabel &&

                            <div className='status-container'>                           
                                {this.props.statusList.map((statusList,i)=>(
                                <div key={i} className="external-wrapper">
                                        <div className='first-layer'>
                                            <div className='main-container'>
                                                <div className='circle-container'>
                                                    {
                                                        statusList["dateCompleted"]!=null ?
                                                        <Icons
                                                            customClassName="icon-circle-plus"
                                                            name="check-circle-solid"
                                                            size="48px"
                                                            containerClass="icon-circle-plus-container"
                                                        />                                         
                                                        :
                                                        i + 1
                                                    }                                                                                  
                                                </div>                   
                                            </div>
                                            {
                                                i + 1 < this.props.statusList.length &&
                                                <div className={`circle-horizontal ${statusList["dateCompleted"]!=null && "circle-active"}`}></div>
                                            }
                                        
                                        </div> 
                                        <div>
                                            <div className='status-header'>
                                                {statusList["status"]}
                                            </div> 
                                            <div className='status-label'>
                                                {
                                                    statusList["dateCompleted"]!=null ?
                                                    <p>Completed On</p>                                           
                                                    :
                                                    ""
                                                }
                                                <span>{statusList["dateCompleted"]}</span>
                                            </div>
                                        </div>
                                </div>
                                ))}
                            
                        </div>
                        }

                       
                        <div>
                            {this.props.listData &&
                               <ListTabButton listData={this.props.listData} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
                            }
                           
                        </div>

                        {this.props.children}
                 </div>
            </div>
        );
    }
}